import React, { useState, useEffect } from "react";
import { Button } from "react-bootstrap";
import { FaSort, FaSortDown, FaSortUp } from "react-icons/fa";
import deleteIcon from "../../Assets/Images/delete icon.png";
import editIcon from "../../Assets/Images/edit icon.svg";
import { ToysTableApi } from "../../Utils/API/ToysTableApi";
import Pagination from "../Pagination/Pagination";
import { Modals } from "../Modals/Modals";
import EditModal from "../Modals/EditToy";
import { DeleteToysApi, ViewToysApi } from "../../Utils/API/ApiCall";
import { ToastContainer, toast } from "react-toastify";
import Loader from "../../Components/Loader/Loader";
import sortUp from "../../Assets/Images/sortup.png";
import sortDown from "../../Assets/Images/sortdown.png";

const ToysTable = ({ SearchValue }) => {
  const [modalShow, setModalShow] = useState(false);
  const [editModalShow, setEditModalShow] = useState(false);
  const [indexer, setIndexer] = useState("");
  const [isDelete, setIsDelete] = useState(false);
  const [toyDatalist, setToyDatalist] = useState([]);
  const [limit, setLimit] = useState(0);
  const [totalPageCount, setTotalPageCount] = useState(0);
  const [pageNumber, setPageNumber] = useState(0);
  const [editIndexer, setEditIndexer] = useState();
  const [sortClick, setSortClick] = useState(1);
  const [loading, setLoading] = useState(false);
  const [toyName, setToyName] = useState("");

  useEffect(() => {
    if (isDelete == true) {
      handleDelete(indexer);
      setModalShow(false);
      setIsDelete(false);
    }
  }, [isDelete]);

  useEffect(() => {
    setLoading(true);
    ToyListdata();
  }, [pageNumber, sortClick, SearchValue]);

  const ToyListdata = async () => {
    const data = {
      limit: 10,
      current_page: SearchValue ? 0 : pageNumber,
      sort_type: sortClick,
      column_name: "title",
      search_value: SearchValue,
    };
    const Response = await ViewToysApi(data);
    setLoading(false);
    setToyDatalist(Response.data.toys);
    setLimit(Response.data.limit);
    setTotalPageCount(Response.data.total_rows);
  };

  const handleDelete = async () => {
    const data = {
      toy_category_id: indexer,
    };
    const Response = await DeleteToysApi(data);
    if (Response.status === 200) {
      toast.success(Response.message);
      setTimeout(() => {
        window.location.reload();
      }, 3000);
    }else{
      toast.error(Response.message);
      setTimeout(() => {
        window.location.reload();
      }, 3000);
    }
  };

  const handleBreedname = async (payload) => {
    const data = {
      toy_category_id: payload,
    };
    // const Response = await EditPlaceholderBreedApi(data)
  };
  const handleClickEdit = (data) => {
    setEditModalShow(true);
    handleBreedname(data.toy_category_id);
    setEditIndexer(data);
  };

  const handleEditHide = () => {
    setEditModalShow(false);
    window.location.reload();
  };

  return (
    <>
      {loading ? <Loader /> : ""}
      <div className="TableMain">
        <table>
          <thead>
            <tr>
              <th className="tablehead">
                <div className="tableheaders">
                  Toys List
                  <div className="SortButton">
                    <img
                      src={sortUp}
                      onClick={() => {
                        setSortClick(2);
                      }}
                    />
                    <img
                      src={sortDown}
                      onClick={() => {
                        setSortClick(1);
                      }}
                    />
                  </div>
                </div>
              </th>
              <th className="tablehead">
                <div className="tableheaders">Actions</div>
              </th>
            </tr>
          </thead>
          <tbody id="TBody">
            {toyDatalist?.length > 0 ? (
              toyDatalist.map((item, i) => {
                return (
                  <tr key={i}>
                    <td>{item.title}</td>
                    <td>
                      <div className="table-action">
                        <img
                          loading="lazy"
                          title="Delete"
                          src={deleteIcon}
                          onClick={() => {
                            setModalShow(true);
                            setIndexer(item.toy_category_id);
                            setToyName(item.title);
                          }}
                        />
                        <img
                          loading="lazy"
                          title="Edit"
                          src={editIcon}
                          onClick={() => {
                            handleClickEdit(item);
                          }}
                        />
                      </div>
                    </td>
                  </tr>
                );
              })
            ) : (
              <td className="NoDataAvailable" colSpan={2}>
                <p className="NoDataAvailable">No data available!</p>
              </td>
            )}
          </tbody>
        </table>
        {totalPageCount > 10 ? (
          <>
            <Pagination
              Limit={limit}
              SetPageNumber={setPageNumber}
              TotalPageCount={totalPageCount}
            />
          </>
        ) : (
          <></>
        )}
        <Modals
          show={modalShow}
          onHide={() => setModalShow(false)}
          setIsDelete={setIsDelete}
          head={
            "Are you sure you want to remove " + toyName + " from the list?"
          }
        />
        <EditModal
          show={editModalShow}
          onHide={handleEditHide}
          head="Edit the toy name"
          detail="You can edit the new toy here"
          // placeholder={breedPlaceholder}
          value={editIndexer}
          editIndexer={editIndexer}
        />
      </div>
    </>
  );
};

export default ToysTable;
